(function () {
    'use strict';

    angular
        .module('app.clubAdmin')
        .constant('clubContactResolver', {
            contacts: getClubContacts,
            clubId: getClubId
        });

    getClubContacts.$inject = ['$transition$', 'Club'];
    function getClubContacts($transition$, Club) {
        var clubId = getClubId($transition$);
        return Club.getClubContacts({ id: clubId }, true);
    }

    getClubId.$inject = ['$transition$'];
    function getClubId($transition$) {
        return $transition$.params().clubId;
    }
    
})();